import React from "react";

export const RequiredIcon = () => {
  return <span style={{ color: "red" }}> *</span>;
};
